import { i18next } from './i18next_init';
import { 
  loadLanguage,
  languageSelectorInteractions,
  scanHtml,
  scanHtmlAndTranslate,
  buildDataTranslation
} from './helpers';

var isNotBot = !/bot|googlebot|crawler|spider|robot|crawling|Chrome-Lighthouse/i.test(navigator.userAgent);

if(isNotBot) {
  let {
    indirectTranslations,
    currentLangIso,
    supportedLanguages,
    additionalSeparator
  } = window.multilingual_settings;

  let firstLoad = true;
  i18next.on('languageChanged', async (lang) => {
    if(firstLoad) {
      i18next.loadedLanguages = [];
      await scanHtml();
    }

    //this updates the cart attribute to know the language of the user when they checkout
    fetch(`/cart/update.js?attributes[Language]=${i18next.language}`);
    
    /**
     * when the page just loaded it falls in the else. On page load, we don't need to
     * translate all the html, but we still to load the languages texts
     * for things that can load later (ex: ajax cart)
     * 
     * On later languageChanged, we need to translate the html. 
     */
    if(!firstLoad || (firstLoad && i18next.language != currentLangIso)) {
      loadLanguage(i18next.language, true);
    }
    else {
      loadLanguage(i18next.language);
    }

    i18next.languageIndex = supportedLanguages.indexOf(i18next.language);
    
    firstLoad = false;
  });


  languageSelectorInteractions();

  if (document.readyState === "complete" || document.readyState === "loaded" || document.readyState === "interactive") {
    multilingualMutationObserver();
  }
  else {
    document.addEventListener('DOMContentLoaded', function(){ 
      multilingualMutationObserver();
    });
  }
  

  function multilingualMutationObserver() {
    const observer = new MutationObserver((mutationsList) => {
      for(let i = 0; i < mutationsList.length; i++){
        setTimeout(function(){
          const mutation = mutationsList[this];

          if(mutation.addedNodes.length > 0) {
            for(let j = 0; j < mutation.addedNodes.length; j++) {
              setTimeout(function() {
                const addedNode = mutation.addedNodes[this];

                for(let k = 0; k < indirectTranslations.length; k++) {
                  setTimeout(function() {
                    const indirectTranslation = indirectTranslations[this];
                    let {
                      cssSelector,
                      translation,
                      useInnerText,
                      attr
                    } = indirectTranslation;

                    if(addedNode.parentElement && addedNode.parentElement.querySelector(cssSelector)){
                      const elementsToTranslate = addedNode.parentElement.querySelectorAll(cssSelector);

                      elementsToTranslate.forEach(($element) => {
                        if(!$element.hasAttribute("data-i18n") && !$element.hasAttribute("data-i18n-key")) {
                          let options = {}
                          if(useInnerText) {
                            let innerText;
                            if(attr) {
                              innerText = $element.getAttribute(attr);
                              options.attr = attr;
                            }
                            else {
                              innerText = $element.innerHTML;
                            }

                            translation = innerText.replace("<p>||</p>", "||");

                            if(additionalSeparator) {
                              translation = translation.replace("<p>" + additionalSeparator + "</p>", additionalSeparator);
                            }
                          }

                          $element.setAttribute('data-i18n', buildDataTranslation(translation, options));
                          scanHtmlAndTranslate($element.parentElement);
                        }
                      })
                    }
                  }.bind(k), 0)
                }

                scanHtmlAndTranslate(addedNode.parentElement);
              }.bind(j), 0);
            }
          }
          else if (mutation.type === "attributes" && mutation.attributeName !== "id" && mutation.attributeName !== "style" && mutation.attributeName !== "data-i18n" && mutation.attributeName !== "data-old-translation") {
            if (mutation.target.hasAttribute('data-i18n')) {
              scanHtmlAndTranslate(mutation.target.parentElement);            
            }
          }
        }.bind(i), 0);
      }
    });

    observer.observe(document.body, {
      childList: true,
      attributes: false,
      subtree: true
    });
  }
}